import { CountryConfig } from "../../shared/types";
import { uaeFormRegistry } from "./formRegistry";
import { ReactComponent as UAEFlag } from "../../assets/uae-flag.svg";
import { PURPOSE_DESCRIPTION_OPTIONS } from "../../shared/const";

export const uaeConfig: CountryConfig = {
  code: "AED",
  name: "United Arab Emirates",
  flag: UAEFlag,
  currencyCode: "AED",
  formRegistry: uaeFormRegistry,
  paymentMethods: [
    { name: "Bank Transfer", value: "bank_transfer" },
  ],
  paymentPurposes: PURPOSE_DESCRIPTION_OPTIONS,
  steps: [
    {
      id: "amount",
      type: "amount",
      title: "Amount",
      stepTitle: "How much are you sending?",
    },
    {
      id: "beneficiary",
      type: "beneficiary",
      title: "Beneficiary",
      stepTitle: "Beneficiary details",
    },
    {
      id: "review",
      type: "review",
      title: "Review",
      stepTitle: "Review the details of your transaction",
    },
  ],
};
